import { createSlice } from '@reduxjs/toolkit';
import { MOBILE_CHECKIN } from '../../config/Constant';

const initialState = {
  preCheckInWidgetState: MOBILE_CHECKIN,
  bookingStatus: {
    isBookingFound: false,
    bookingData: {},
  },
  preCheckInStatus: {
    preCheckInCompleted: false,
    preCheckInData: {}
  },
  supportedCardValidationFlow: ['ElavonLB', "PCIPROXY", "Shift4"],
  supportedAccompanyGuestFlow: ['guestNames', "dynamicGuestInfo"],

  guestAllowedDocumentListData: []
};

const checkInSlice = createSlice({
  name: 'checkIn',
  initialState,
  reducers: {
    resetPreCheckInConfig: () => initialState,
    setBookingStatus: (state, action) => {
      const { isBookingFound, bookingData = {} } = action.payload;
      state.bookingStatus = {
        isBookingFound,
        bookingData: isBookingFound ? { ...bookingData } : {},
      };
    },
    setPreCheckInWidgetState: (state, action) => {
      state.preCheckInWidgetState = action.payload;
    },
    setPreCheckInStatus: (state, action) => {
      const { preCheckInCompleted, preCheckInData = {} } = action.payload;
      state.preCheckInStatus = {
        preCheckInCompleted,
        preCheckInData: preCheckInCompleted ? { ...preCheckInData } : {},
      };
    },
  },
});

export const { resetPreCheckInConfig, setBookingStatus, setPreCheckInWidgetState, setPreCheckInStatus } = checkInSlice.actions;

export default checkInSlice.reducer;